import { User } from './auth.types';

export enum RequestStatus {
  DRAFT = 'DRAFT',
  PENDING_MANAGER = 'PENDING_MANAGER',
  PENDING_SENIOR_MANAGER = 'PENDING_SENIOR_MANAGER',
  PENDING_GENERAL_MANAGER = 'PENDING_GENERAL_MANAGER',
  PENDING_FINANCE = 'PENDING_FINANCE',
  PENDING_CFO = 'PENDING_CFO',
  MORE_INFO_NEEDED = 'MORE_INFO_NEEDED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  PAID = 'PAID',
  CLOSED = 'CLOSED'
}

export enum RequestCategory {
  AI_TOOLS = 'AI_TOOLS',
  HARDWARE = 'HARDWARE',
  SOFTWARE_LICENSE = 'SOFTWARE_LICENSE',
  OTHER = 'OTHER'
}

export enum RequestUrgency {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export enum RequestFrequency {
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  ONCE = 'ONCE'
}

export interface PurchaseRequest {
  id: string;
  title: string;
  description: string;
  amount: number;
  currency: string;
  category: RequestCategory;
  status: RequestStatus;
  urgency: RequestUrgency;
  frequency: RequestFrequency;
  createdAt: Date;
  updatedAt: Date;
  paidAt?: Date;
  closedAt?: Date;
  departmentId: string;
  department: {
    id: string;
    name: string;
  };
  requesterId: string;
  requester: User;
  approverId?: string;
  approver?: User;
  justification?: string;
  vendorName?: string;
  vendorLink?: string;
  budgetCode?: string;
  requestedDeliveryDate: Date;
  attachments: Attachment[];
  comments: Comment[];
  managerApprovedAt?: Date;
  financeApprovedAt?: Date;
  rejectionReason?: string;
  creditCardLastFour?: string;
  // Payment information (available throughout workflow)
  paymentType?: string;
  paymentReference?: string;
}

export interface Attachment {
  id: string;
  filename: string;
  fileUrl: string;
  fileType: string;
  createdAt: Date;
  requestId: string;
}

export interface Comment {
  id: string;
  content: string;
  createdAt: Date;
  updatedAt: Date;
  requestId: string;
  userId: string;
  user: User;
}

export interface CreatePurchaseRequestDto {
  title: string;
  description: string;
  amount: number;
  currency: string;
  category: RequestCategory;
  urgency: RequestUrgency;
  frequency: RequestFrequency;
  justification: string;
  vendorName?: string;
  vendorLink?: string;
  budgetCode?: string;
  requestedDeliveryDate: Date;
  attachments?: File[];
  // Optional payment information (can be filled at creation or later)
  paymentType?: string;
  paymentReference?: string;
} 